"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GuidelineHistoryWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _badge = require("@design/ui/badge");
var _card = require("@design/ui/card");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function GuidelineField(_ref) {
  var label = _ref.label,
    value = _ref.value;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1",
    "data-sentry-component": "GuidelineField",
    "data-sentry-source-file": "GuidelineHistoryWidget.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-label-sm uppercase tracking-wide text-foreground-muted",
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "whitespace-pre-wrap",
      children: value
    })]
  });
}
var GuidelineHistoryWidgetComponent = function GuidelineHistoryWidgetComponent(_ref2) {
  var data = _ref2.data;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    size: "sm",
    className: (0, _utils.cn)("my-2", data.dismissed && "opacity-70"),
    "data-sentry-element": "Card",
    "data-sentry-component": "GuidelineHistoryWidgetComponent",
    "data-sentry-source-file": "GuidelineHistoryWidget.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardHeader, {
      "data-sentry-element": "CardHeader",
      "data-sentry-source-file": "GuidelineHistoryWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardTitle, {
        className: "flex items-center gap-2",
        "data-sentry-element": "CardTitle",
        "data-sentry-source-file": "GuidelineHistoryWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          className: "size-4 text-muted-foreground",
          "data-sentry-element": "svg",
          "data-sentry-source-file": "GuidelineHistoryWidget.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M9 11l3 3L22 4",
            "data-sentry-element": "path",
            "data-sentry-source-file": "GuidelineHistoryWidget.tsx"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11",
            "data-sentry-element": "path",
            "data-sentry-source-file": "GuidelineHistoryWidget.tsx"
          })]
        }), "Guideline Rule Suggestion"]
      }), data.dismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardAction, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
          variant: "secondary",
          children: "Dismissed"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "GuidelineHistoryWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(GuidelineField, {
        label: "Rule Name",
        value: data.name,
        "data-sentry-element": "GuidelineField",
        "data-sentry-source-file": "GuidelineHistoryWidget.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(GuidelineField, {
        label: "Guideline",
        value: data.rule,
        "data-sentry-element": "GuidelineField",
        "data-sentry-source-file": "GuidelineHistoryWidget.tsx"
      }), data.comment && /*#__PURE__*/(0, _jsxRuntime.jsx)(GuidelineField, {
        label: "Comment",
        value: data.comment
      })]
    })]
  });
};
var GuidelineHistoryWidget = exports.GuidelineHistoryWidget = /*#__PURE__*/_react.default.memo(GuidelineHistoryWidgetComponent);
var _default = exports.default = GuidelineHistoryWidget;